export default "__VITE_ASSET__Clhj8tOp__"